module.exports = __webpack_public_path__ + "img/decast-icon.7a464462.svg";